import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Orion from "./NoData_Orion";
import ChartLoader_Orion from "./ChartLoader_Orion";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketTable_neteng_Orion from "./BucketTable_neteng_Orion";
import BucketTable_netkwh_Orion from "./BucketTable_netkwh_Orion";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";

export default function NetEnergyConsumptionkwh_Orion({ apiend, gloablfilter, title, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState("median_whPerKM");

  const appyDatakwh = (data) => {
    if (type === "netenergy")
      SetFieldName("median_whPerKM")
    else
      SetFieldName("median_NetkWh")
    const res_result = data;
    let res_result_final = []
    let responcekwh = {
      "<50": 0,
      "75": 0,
      "100": 0,
      "125": 0,
      "150": 0,
      "175": 0,
      "200": 0,

      // "<=147": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;

      temp_result.map(d => {
        let value = parseFloat(d.median_NetkWh.values["50.0"]);
        if (isNaN(value))
          value = 0
        if ((d.median_NetkWh.values["50.0"] === null))
          d.median_NetkWh.values["50.0"] = 0.00000
        if (value < 50) {
          responcekwh["<50"] = responcekwh["<50"] + 1;
        } else if (value >= 50 && value < 75) {
          responcekwh["75"] = responcekwh["75"] + 1;
        } else if (value >= 75 && value < 100) {
          responcekwh["100"] = responcekwh["100"] + 1;
        } else if (value >= 100 && value < 125) {
          responcekwh["125"] = responcekwh["125"] + 1;
        }else if (value >= 125 && value < 150) {
          responcekwh["150"] = responcekwh["150"] + 1;
        }else if (value >= 150 && value < 200) {
          responcekwh["200"] = responcekwh["200"] + 1;
        }
        // else if (value >= 147) {
        //   responcekwh["<=147"] = responcekwh["<=147"] + 1;
        // }
      })
      res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responcekwh);
      // loop_keys = ["<50", "75", "100", "125", "150", ">150"]
      loop_keys = ["<50", "75", "100", "125","150","175","200" /*  "<=147" */]
      loop_keys.map(x => {
        // res_result_final.push([x, responcekwh[x], "#83A4CF"]);
        res_result_final.push([x, responcekwh[x], "stroke-width: 1;stroke-color: black;"]);
      })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }
  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'kWh',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "orion_drive_api/" + apiend, body: { filterdata: gloablfilter } }, appyDatakwh)
  }, [gloablfilter, apiend])

  return (
    <>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader_Orion /> : ((chartdata.length == 0) ? <NoData_Orion /> : <Chart chartType="ColumnChart" width="100%" height="210px" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                const barvalue = chartWrapper.getDataTable().Wf[row].c[0].v;
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                if (count != 0) {
                  let filtered_temp = [];

                  if ((fieldname === "median_NetkWh")) {
                    filtered_temp = apiresponce.filter(x => {

                      if (x.median_NetkWh.values["50.0"] < barvalue && x.median_NetkWh.values["50.0"] >= barvalue - 25) {

                        return x;
                      }
                      // else if (x.median_NetkWh.values["50.0"] >= 147 && barvalue === "<=147") {
                      else if (x.median_NetkWh.values["50.0"] >= 200 && barvalue === "200") {
                        return x
                      }
                      else if (x.median_NetkWh.values["50.0"] < 50 && barvalue === "<50") {
                        return x
                      }
                    })
                  }

                  function compareObjects(object1, object2, key) {
                    let obj1 = []
                    let obj2 = []
                    if (fieldname === "median_whPerKM") {
                      obj1 = object1.median_whPerKM.values["50.0"]
                      obj2 = object2.median_whPerKM.values["50.0"]
                    }
                    else if (fieldname === "median_NetkWh") {
                      obj1 = object1.median_NetkWh.values["50.0"]
                      obj2 = object2.median_NetkWh.values["50.0"]
                    }
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'vehicalId')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + apiend).modal('show');
                }
              }
            }
          }
        ]}
        />)}

        <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{"kWh"}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
              <div className="modal-body">
                {/* <table className="table table-striped">
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                    <tr>
                      <th scope="col">Vin Number</th>
                      <th scope="col">value</th>
                    </tr></thead>
                  <tbody> */}
                <BucketTable_netkwh_Orion data={filteredData} />
                {/* </tbody></table> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
